import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';

class Article extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props) {
        super(props);

        this.state = {};
    }
    generateContent = (item, index) => {
        if (item.type === 'text') {
            return <div dangerouslySetInnerHTML={{ __html: item.data }} key={index} />;
        }
        if (item.type === 'video') {
            return (
                <p key={index}>
                    <video
                        muted
                        controls="controls"
                        preload="auto"
                        controlsList="nodownload"
                        poster={item.data.bigPosterUrl}
                        src={item.data.playUrl}
                    />
                </p>
            );
        }
    };
    render() {
        const { content } = this.props;

        return (
            <div className={styles.phtv_text}>
                {content.contentList
                    ? content.contentList[0].map((item, index) => {
                          return this.generateContent(item, index);
                      })
                    : ''}
            </div>
        );
    }
}

export default errorBoundary(Article);
